import React from "react";
import { Alert, ListGroup, ListGroupItem } from "react-bootstrap";
import Dashlet from "../../controls/Dashlet";
import EmptyPlaceholder from "../../controls/EmptyPlaceholder";
import Icon from "../../controls/Icon";
import { IconButton } from "../../controls/TooltipControls";
import opn from "../../util/opn";
import { MainContext } from "../../views/MainWindow";
function NewsExtra(props) {
    const { t, item } = props;
    const { value, icon, text } = item;
    let count;
    {
        const tmp = new Number(value).valueOf();
        if (!Number.isNaN(tmp)) {
            count = tmp;
        }
    }
    return (React.createElement("div", null,
        React.createElement(Icon, { name: icon }),
        t(text, { replace: { value, count }, count })));
}
function NewsItem(props) {
    const { t, item, title } = props;
    const { category, extra, imageUrl, link, name, summary } = item;
    const context = React.useContext(MainContext);
    const openMore = React.useCallback((evt) => {
        context.api.events.emit("analytics-track-click-event", "Dashboard", `View ${title}`);
        evt.preventDefault();
        opn(link).catch((err) => undefined);
    }, [link, title]);
    return (React.createElement(ListGroupItem, { className: "rss-item" },
        category ? React.createElement("div", { className: "rss-category" }, category) : null,
        React.createElement("div", { className: "rss-image", style: {
                background: imageUrl !== undefined ? `url(${imageUrl})` : undefined,
            } }),
        React.createElement("h4", null,
            React.createElement("a", { href: link, onClick: openMore }, name)),
        React.createElement("p", { className: "rss-summary" }, summary),
        extra !== undefined ? (React.createElement("div", { className: "rss-extras" }, extra.map((iter, idx) => (React.createElement(NewsExtra, { key: idx, t: t, item: iter }))))) : null));
}
function BaseDashlet(props) {
    const { t, emptyText, error, items, onRefresh, title } = props;
    return (React.createElement(Dashlet, { className: "dashlet-news", title: title },
        onRefresh !== undefined ? (React.createElement(IconButton, { className: "issues-refresh", icon: "refresh", tooltip: t("Refresh"), onClick: onRefresh })) : null,
        error !== undefined ? React.createElement(Alert, null, t("No messages received")) : null,
        (items ?? []).length !== 0 ? (React.createElement(ListGroup, { className: "list-news" }, items.map((msg, idx) => (React.createElement(NewsItem, { key: idx, t: t, item: msg, title: title }))))) : (React.createElement(EmptyPlaceholder, { icon: "layout-list", text: emptyText, subtext: t("*crickets chirp*") }))));
}
export default BaseDashlet;
